module.exports = __webpack_public_path__ + "img/product_6.08cfbc5.webp";